import $ from 'jquery';

$('.infobar__navigation-item').on('click', function() {
    var target = $(this).attr('data-target');
    var $contentWrap = $(this).parent().siblings('.infobar__tabs');

    if($(this).hasClass('infobar__navigation-item--active')) {
        $(this).removeClass('infobar__navigation-item--active');
        $contentWrap.find('.infobar__tab').removeClass('infobar__tab--active');
        $contentWrap.removeClass('infobar__tabs--active');
    }
    else {
        $contentWrap.addClass('infobar__tabs--active');
        $(this).siblings().removeClass('infobar__navigation-item--active');
        $(this).addClass('infobar__navigation-item--active');
        $contentWrap.find('.infobar__tab').removeClass('infobar__tab--active');
        $contentWrap.find('[data-tab="'+ target +'"]').addClass('infobar__tab--active');

    }
});

$('.infobar__close').on('click', function() {
    var $parent = $(this).parents('.infobar');
    $parent.find('.infobar__navigation-item').removeClass('infobar__navigation-item--active');
    $parent.find('.infobar__tab').removeClass('infobar__tab--active');
    $parent.find('.infobar__tabs').removeClass('infobar__tabs--active');
});

$(document).on('click', function(event) {
    if ($(window).width() >= 768 && !$(event.target).closest('.infobar').length) {
        $('.infobar__close').trigger('click');
    }
});
